import { useQuery } from "@tanstack/react-query";
import { client } from "@johnpaul/jp-api-client";
import { ComponentData, JPClientRequest } from "@companion-core/shared/app/Interfaces/API";

type DetailPageParams = {
  parentID: string;
  lang: string;
  contentType: string;
};

export const useDetailPage = <T = ComponentData>({
  parentID,
  lang,
  contentType,
}: DetailPageParams) => {
  return useQuery({
    queryKey: ["detail-page", parentID, lang],
    queryFn: () =>
      client.content.v2.components.get(null, {
        "parent_id": parentID,
        lang,
        state: contentType !== "vendor" ? "published,scheduled,draft" : "",
      }),
    select: (data: JPClientRequest<T>): T | null =>
      data.data.results.length > 0 ? data.data.results[0] : null,
    gcTime: 0,
  });
};
